module.exports = __webpack_public_path__ + "img/notifications--icon.3388663b.svg";